



















import {
  computed,
  toRefs,
  PropType,
  defineComponent,
  getCurrentInstance
} from "vue";
import { DpaIdCollabFolderDialog } from "@dpa-connect/dpa-id-collab";
import useCollaboration from "@/composition/useCollaboration";
import { NewsItem } from "@/store/modules/newsItems/types.d";

export default defineComponent({
  components: {
    DpaIdCollabFolderDialog
  },
  props: {
    newsItem: {
      type: Object as PropType<NewsItem>,
      required: true
    }
  },
  setup(props) {
    const root = getCurrentInstance();
    const { newsItem } = toRefs(props);

    const {
      showCollabDialog,
      dialogEventId,
      existingFolderListItem,
      collabDialogMode,
      formattedItem,
      sidebarFolder,
      setShowCollabDialog,
      handleCollabDialogSuccess,
      setFolderItemsQueryVariables
    } = useCollaboration(newsItem);

    // Make sure the thumbnail was fetched for the news item. This way, the `formattedItem` ref in the collaboration composable can read it synchronously.
    root.proxy.$store.dispatch("collaboration/fetchThumbnailForNewsItem", {
      event: newsItem.value
    });

    const existingItems = computed(() =>
      existingFolderListItem.value ? [existingFolderListItem.value] : []
    );

    const items = computed(() => [
      {
        type: "folderListItem",
        itemValueUnit: formattedItem.value
      }
    ]);

    const isDialogForNewsItem = computed(() => {
      // @ts-ignore
      return dialogEventId.value === newsItem.value.guid;
    });

    return {
      newsItem,
      items,
      isDialogForNewsItem,
      // collab members
      collabDialogMode,
      dialogEventId,
      existingItems,
      formattedItem,
      handleCollabDialogSuccess,
      setShowCollabDialog,
      setFolderItemsQueryVariables,
      showCollabDialog,
      sidebarFolder
    };
  }
});
